<template>
    <div id="login">
        <fwl-preloader v-if="isLoading"></fwl-preloader>

        <div class="login_select-idiom p-2 mt-1">
            <fwl-select-language class="m-0 p-0"
                                 :languages="languages"
                                 :language="language"
                                 v-on:change-language="ChangeLanguage">
            </fwl-select-language>
        </div>

        <div>
            <div class="card-login letrasblancas">
                <figure>
                    <img alt="FwLogistic" :src="logoPath" class="logo-white">
                </figure>

                <form class="form-login w-100" v-on:submit.prevent="login">
                    <div class="mb-2">
                        <label class="w-40" v-if="askCompanyOnLogin">
                            <span>{{ $t("company") }}</span>
                            <input type="text"
                                   @input="onCompanyInput"
                                   v-model="company"
                                   class="form-control p-1"
                                   name="company_name"
                                   id="company"
                                   ref="company"
                                   :placeholder="$t('company')">
                        </label>
                    </div>
                    <div class="d-flex d-flex-center">
                        <label class="w-40">
                            <span>{{ $t("username") }}</span>
                            <input :type="usernameInputType"
                                   v-model="email"
                                   class="form-control p-1"
                                   name="email"
                                   required
                                   id="email"
                                   ref="email"
                                   :placeholder="$t('username')">
                        </label>
                        <label class="ml-1 w-40">
                            <span>{{ $t("password") }}</span>
                            <input type="password"
                                   v-model="password"
                                   class="form-control p-1"
                                   name="password"
                                   id="password"
                                   ref="password"
                                   :placeholder="$t('password')">
                        </label>
                        <button type="submit" id="sendlogin" class="btn btn-login ml-1"></button>
                    </div>
                </form>

                <div class="text-center mt-2 m-auto">
                    <span style="text-decoration: underline red;" v-if="error">{{ $t("error") }}</span>
                </div>
            </div>
        </div>

        <fwl-modal-error-unauthorized v-if="showUnauthorizedModal" v-on:close="showUnauthorizedModal = false" />
    </div>
</template>

<script>
    import { urlGetLoginTraslate, urlLogin, urlApp } from './routes.app.js';

    const LOGIN_CONTEXT_STORAGE_KEY = 'fwlAnalyst.loginContext';
    const LAST_COMPANY_LOOKUP_KEY = '__last_company__';
    const AUTOFILL_SYNC_ATTEMPTS = 10;
    const AUTOFILL_SYNC_INTERVAL_MS = 300;

    export default {
        name: 'Login',

        props: {
            usernameInputType: {
                type: String,
                default: 'text'
            },
            logoPath: {
                type: String,
                default: './Content/assets/Images/Login_logo_blanco.svg'
            }
        },

        data() {
            return {
                askCompanyOnLogin: window.askCompanyOnLogin || false,
                language: this.getInitialLanguage(),
                languages: [
                    {
                        acronym: "es",
                        name: "Español",
                        dictionaryId: "es",
                        img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAFnSURBVHjaYvzPgAD/UNlYEUAAmuTYAAAQhAEYqF/zFbe50RZ1cMmS9TLi0pJLRjZohAMTGFUN9HdnHgEE1sDw//+Tp0ClINW/f0NIKPoFJH/9//ULyGaUlQXaABBALAx/Gf4zAt31F4i+ffj3/cN/XrFfzOx//v///f//LzACM/79ZmD8/e8TA0AAMYHdDVT958vXP38nMDB0s3x94/Tj5y+YahhiAKLfQKUAAcQEdtJfoDHMF2L+vPzDmFXLelf551tGFOOhev4A/QgQQExgHwAd8IdFT/Wz6j+GhlpmXSOW/2z///8Eq/sJ18Dw/zdQA0AAMQExxJjjdy9x2/76EfLz4MXdP/i+wsyGkkA3Aw3984cBIIAYfzIwMKel/bt3jwEaLNAwgZIQxp/fDH/+MqqovL14ESCAWICeZvr9h0FSEhSgwBgAygFDEMT+wwAhgQgc4kAEVAwQQIxfUSMSTxxDAECAAQAJWke8v4u1tAAAAABJRU5ErkJggg=="
                    },
                    {
                        acronym: "en",
                        name: "English",
                        dictionaryId: "en",
                        img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAflJREFUeNpinDRzn5qN3uFDt16+YWBg+Pv339+KGN0rbVP+//2rW5tf0Hfy/2+mr99+yKpyOl3Ydt8njEWIn8f9zj639NC7j78eP//8739GVUUhNUNuhl8//ysKeZrJ/v7z10Zb2PTQTIY1XZO2Xmfad+f7XgkXxuUrVB6cjPVXef78JyMjA8PFuwyX7gAZj97+T2e9o3d4BWNp84K1NzubTjAB3fH0+fv6N3qP/ir9bW6ozNQCijB8/8zw/TuQ7r4/ndvN5mZgkpPXiis3Pv34+ZPh5t23//79Rwehof/9/NDEgMrOXHvJcrllgpoRN8PFOwy/fzP8+gUlgZI/f/5xcPj/69e/37//AUX+/mXRkN555gsOG2xt/5hZQMwF4r9///75++f3nz8nr75gSms82jfvQnT6zqvXPjC8e/srJQHo9P9fvwNtAHmG4f8zZ6dDc3bIyM2LTNlsbtfM9OPHH3FhtqUz3eXX9H+cOy9ZMB2o6t/Pn0DHMPz/b+2wXGTvPlPGFxdcD+mZyjP8+8MUE6sa7a/xo6Pykn1s4zdzIZ6///8zMGpKM2pKAB0jqy4UE7/msKat6Jw5mafrsxNtWZ6/fjvNLW29qv25pQd///n+5+/fxDDVbcc//P/zx/36m5Ub9zL8+7t66yEROcHK7q5bldMBAgwADcRBCuVLfoEAAAAASUVORK5CYII"
                    },
                    {
                        acronym: "pt",
                        name: "Português",
                        dictionaryId: "pt",
                        img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAHjSURBVHjaYmRIZkCAfwwMf2DkLzCCMyDoBwNAALEAlTVGN/5nYPj//x8Q/P3/9++/vzZa31gY/mw5z/Tn3x8g98+f37///fn99/eq2lUAAQTS8J/h/7NPz/9C5P79WRj89f9/zv//fjtLvPVezPzrz+8/f3//+vtLhl8GaANAAIE1/P8PVA1U6qn7NVTqb1XVpAv/JH7/+a/848XmtpBlj39PO8gM1PP7z2+gqwACiAnoYpC9TF9nB34NVf5z4XpoZJbEjJKfWaEfL7KLlbaURKj8Opj08RfIVb+BNgAEEBPQW1L8P+b6/mb6//s/w+/+nc4F0/9P2cj65xdHc+p/QR39//9/AdHJ9A/60l8YvjIABBAT0JYH75jStv75zwCSMBY8BXTMxXv/21ezfHj9X5/3BESDy5JfBy7/ZuBnAAggkA1//vx594kpaCnLloe/smLaVT9/ff3y/+/P/w+u/+JuW7fhwS/tSayPXrOycrEyfGQACCAWoA1//oOCDIgm72fu4vy6b4LD/9/S/3///s9+S28yy+9/LEAf//kLChVgCAEEEEjD7z9/JHgkQeHwD8gUjV79O9r6CzPLv6lr1OUFwWH9Fxjcv//9BcYoA0AAMTI4ImIROUYRMf2XARkABBgA8kMvQf3q+24AAAAASUVORK5CYII="
                    }
                ],
                company: "",
                email: "",
                password: "",
                companyEditedForLookupKey: "",
                lastAppliedRememberedCompany: "",
                isApplyingRememberedCompany: false,
                autofillSyncTimerId: null,
                isLoading: false,
                error: false,
                showUnauthorizedModal: false
            };
        },

        created() {
            this.GetTraslation();
            this.checkSessionExpired();
            this.applyRememberedCompany();
        },

        mounted() {
            this.startAutofillSync();
        },

        beforeUnmount() {
            this.stopAutofillSync();
        },

        watch: {
            language() {
                this.GetTraslation();
            },

            email(newValue, oldValue) {
                if (this.normalizeUsername(newValue) !== this.normalizeUsername(oldValue)) {
                    this.applyRememberedCompany({ username: newValue });
                }
            }
        },

        methods: {
            getDefaultLoginContext() {
                return {
                    lastCompany: "",
                    companiesByUsername: {},
                    updatedAt: null
                };
            },

            getInitialLanguage() {
                try {
                    const stored = localStorage.getItem("language");
                    if (stored) {
                        return JSON.parse(stored);
                    }
                } catch (ex) {
                    return {
                        acronym: navigator.language?.substring(0, 2) || navigator.userLanguage?.substring(0, 2) || "es",
                        dictionaryId: navigator.language?.substring(0, 2) || navigator.userLanguage?.substring(0, 2) || "es"
                    };
                }

                return {
                    acronym: navigator.language?.substring(0, 2) || navigator.userLanguage?.substring(0, 2) || "es",
                    dictionaryId: navigator.language?.substring(0, 2) || navigator.userLanguage?.substring(0, 2) || "es"
                };
            },

            checkSessionExpired() {
                const params = new URLSearchParams(window.location.search);
                if (params.get('sessionExpired') === 'true') {
                    this.showUnauthorizedModal = true;
                    history.replaceState({}, '', window.location.pathname);
                }
            },

            normalizeUsername(value) {
                return typeof value === 'string' ? value.trim().toLowerCase() : "";
            },

            normalizeCompany(value) {
                return typeof value === 'string' ? value.trim() : "";
            },

            getCompanyLookupKey(username) {
                return username || LAST_COMPANY_LOOKUP_KEY;
            },

            getLoginContext() {
                if (!this.askCompanyOnLogin) {
                    return this.getDefaultLoginContext();
                }

                try {
                    const stored = localStorage.getItem(LOGIN_CONTEXT_STORAGE_KEY);
                    if (!stored) {
                        return this.getDefaultLoginContext();
                    }

                    const parsed = JSON.parse(stored);

                    return {
                        lastCompany: typeof parsed?.lastCompany === 'string' ? parsed.lastCompany : "",
                        companiesByUsername: parsed?.companiesByUsername && typeof parsed.companiesByUsername === 'object'
                            ? parsed.companiesByUsername
                            : {},
                        updatedAt: typeof parsed?.updatedAt === 'string' ? parsed.updatedAt : null
                    };
                } catch (ex) {
                    return this.getDefaultLoginContext();
                }
            },

            getRememberedCompany(username) {
                const context = this.getLoginContext();
                const rememberedByUsername = username
                    ? context.companiesByUsername?.[username]
                    : "";

                return rememberedByUsername || context.lastCompany || "";
            },

            applyRememberedCompany(options = {}) {
                if (!this.askCompanyOnLogin) {
                    return;
                }

                const normalizedUsername = this.normalizeUsername(options.username ?? this.email);
                const lookupKey = this.getCompanyLookupKey(normalizedUsername);
                const rememberedCompany = this.getRememberedCompany(normalizedUsername);
                const currentCompany = this.normalizeCompany(this.company);

                if (!rememberedCompany) {
                    return;
                }

                const canOverwrite = !currentCompany
                    || currentCompany === this.lastAppliedRememberedCompany
                    || this.companyEditedForLookupKey !== lookupKey;

                if (!canOverwrite) {
                    return;
                }

                if (currentCompany === rememberedCompany && this.lastAppliedRememberedCompany === rememberedCompany) {
                    return;
                }

                this.isApplyingRememberedCompany = true;
                this.company = rememberedCompany;
                this.lastAppliedRememberedCompany = rememberedCompany;
                this.companyEditedForLookupKey = "";

                this.$nextTick(() => {
                    this.isApplyingRememberedCompany = false;
                });
            },

            persistLoginContext() {
                if (!this.askCompanyOnLogin) {
                    return;
                }

                const companyName = this.normalizeCompany(this.company);
                if (!companyName) {
                    return;
                }

                const normalizedUsername = this.normalizeUsername(this.email);
                const context = this.getLoginContext();

                context.lastCompany = companyName;
                context.updatedAt = new Date().toISOString();

                if (normalizedUsername) {
                    context.companiesByUsername[normalizedUsername] = companyName;
                }

                localStorage.setItem(LOGIN_CONTEXT_STORAGE_KEY, JSON.stringify(context));
                this.lastAppliedRememberedCompany = companyName;
            },

            onCompanyInput() {
                if (this.isApplyingRememberedCompany) {
                    return;
                }

                this.companyEditedForLookupKey = this.getCompanyLookupKey(this.normalizeUsername(this.email));
            },

            syncInputsFromRefs() {
                const emailValue = this.$refs.email?.value;
                const passwordValue = this.$refs.password?.value;

                if (typeof emailValue === 'string' && emailValue !== this.email) {
                    this.email = emailValue;
                }

                if (typeof passwordValue === 'string' && passwordValue !== this.password) {
                    this.password = passwordValue;
                }
            },

            startAutofillSync() {
                this.stopAutofillSync();

                let remainingAttempts = AUTOFILL_SYNC_ATTEMPTS;
                const syncAutofilledState = () => {
                    this.syncInputsFromRefs();
                    remainingAttempts -= 1;

                    if (remainingAttempts > 0) {
                        this.autofillSyncTimerId = window.setTimeout(syncAutofilledState, AUTOFILL_SYNC_INTERVAL_MS);
                    } else {
                        this.autofillSyncTimerId = null;
                    }
                };

                syncAutofilledState();
            },

            stopAutofillSync() {
                if (this.autofillSyncTimerId) {
                    window.clearTimeout(this.autofillSyncTimerId);
                    this.autofillSyncTimerId = null;
                }
            },

            async login() {
                let context = this;
                this.isLoading = true;
                this.error = false;

                const response = await axios.post(
                    urlLogin,
                    {
                        username: context.email,
                        password: context.password,
                        companyName: context.company,
                        language: this.language
                    },
                    { headers: { 'Content-Type': 'application/json' } }
                ).catch(error => {
                    setTimeout(() => { context.isLoading = false }, 500);
                    context.error = true;
                });

                if (response && response.data && response.data.statusText == "success") {
                    this.persistLoginContext();
                    localStorage.setItem("User", JSON.stringify(response.data.data.user));
                    window.location.href = urlApp;
                } else {
                    context.error = true;
                    setTimeout(function () { context.isLoading = false }, 500);
                }
                context.isLoading = false;
            },

            ChangeLanguage(language) {
                this.language = language;
            },

            GetTraslation() {
                try {
                    const messages = this.$i18n.messages;
                    let context = this;
                    this.isLoading = true;

                    axios.post(urlGetLoginTraslate, { language: this.language.dictionaryId })
                        .then(function (response) {
                            if (response.data.statusText == "success") {
                                context.$i18n.messages[context.language.dictionaryId] = response.data.data;
                                context.$i18n.locale = context.language.dictionaryId;
                                localStorage.setItem("language", JSON.stringify(context.language));
                            } else {
                                if (context.language.acronym != "es") {
                                    context.ChangeLanguage({ acronym: "es", dictionaryId: "es", name: "Espa�ol" });
                                }
                            }
                        })
                        .catch((error) => {
                            console.groupCollapsed('GetTraslation axios error');
                            console.error('message:', error.message);

                            if (typeof error.toJSON === 'function') {
                                console.error('toJSON:', error.toJSON());
                            }

                            if (error.response) {
                                console.error('status:', error.response.status, error.response.statusText);
                                console.error('data:', error.response.data);
                                console.error('headers:', error.response.headers);
                            } else if (error.request) {
                                console.error('request (no response):', error.request);
                            } else {
                                console.error('config:', error.config);
                            }
                            console.groupEnd();

                            context.error = true;
                        })
                        .finally(() => {
                            context.isLoading = false;
                        });
                } catch (ex) {
                    console.log(ex);
                }
            }
        }
    };
</script>

<style scoped>

</style>